import React, { useState } from 'react';
import { Box, Chip, IconButton, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Reaction, User } from '../../workers/ApiWorker';


interface ReactionsBarProps {
    reactions: Reaction[];
    canReact?: boolean;              // show add button / allow clicks
    availableEmojis?: string[];      // optional override
    onToggleReaction?: (emoji: string) => void;
    user?: User;
}

const ReactionsBar: React.FC<ReactionsBarProps> = ({
                                                       reactions,
                                                       canReact = false,
                                                       availableEmojis = ['👍', '❤️', '🔥', '👏', '😮', '😀'],
                                                       onToggleReaction,
    user
                                                   }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpenPicker = (event: React.MouseEvent<HTMLElement>) => {
        if (!canReact) return;
        setAnchorEl(event.currentTarget);
    };

    const handleClosePicker = () => {
        setAnchorEl(null);
    };

    const handleSelectEmoji = (emoji: string) => {
        onToggleReaction?.(emoji);
        handleClosePicker();
    };

    const handleChipClick = (emoji: string) => {
        if (!canReact) return;
        onToggleReaction?.(emoji);
    };

    return (
        <>
            <Box
                sx={{
                    mt: 1,
                    mb: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    flexWrap: 'wrap',
                }}
            >
                {reactions?.map((reaction) => (
                    <Chip
                        key={reaction.emoji}
                        label={`${reaction.emoji} ${reaction.count}`}
                        size="small"
                        variant={reaction.reacted ? 'filled' : 'outlined'}
                        onClick={() => {
                            if (canReact && user) handleChipClick(reaction.emoji);
                        }}
                        sx={{
                            fontSize: '0.75rem',
                            borderRadius: '999px',
                            px: 1,
                            cursor: canReact && user ? 'pointer' : 'default',
                            opacity: canReact && user ? 1 : 0.6, // optional visual hint
                        }}
                    />
                ))}

                {canReact && user && (
                    <IconButton size="small" onClick={handleOpenPicker}>
                        <AddIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClosePicker}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                {availableEmojis.map((emoji) => (
                    <MenuItem
                        key={emoji}
                        onClick={() => handleSelectEmoji(emoji)}
                        sx={{ fontSize: '1.2rem' }}
                    >
                        {emoji}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default ReactionsBar;
